import { render, staticRenderFns } from "./ReportBetterRetirementOutcomes.vue?vue&type=template&id=f32b1f2e&"
import script from "./ReportBetterRetirementOutcomes.vue?vue&type=script&lang=js&"
export * from "./ReportBetterRetirementOutcomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports